import useNewC4Journey from './useNewC4Journey';

const useCartReduxKeyName = () => {
  const isNewC4Journey = useNewC4Journey();
  return isNewC4Journey ? 'newCart' : 'cart';
};

export default useCartReduxKeyName;
